﻿import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../../core/config';
import { catchError, finalize } from 'rxjs/operators';
import { ExceptionService } from '../../core/services/exception.service';
import { SpinnerService } from '../../core/spinner/spinner.service';
import { SearchOfflineDebates } from '../../core/models/debates/offline-debates/search-offline-debates';
import { PagedResultModel } from '../../core/models/paged-result.model';
import { OfflineDebateDetail } from '../../core/models/debates/offline-debates/offline-debates-detail';
import { DebateBasicData } from '../../core/models/debates/shared/debate-basic-data';
import { OfflineDebateSessionDetail } from '../../core/models/debates/offline-debates/offline-debate-session-detail';
import { DropdownItem } from '../../core/models/dropdown-item';

@Injectable()
export class OfflineDebatesService {
    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    searchOfflineDebates(data: SearchOfflineDebates): Observable<PagedResultModel> {
        this._spinnerService.show();
        return this._http.post<PagedResultModel>(CONFIG.baseUrls.offlineDebates.searchofflineDebates, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getAllOfflineDebatesForDropdown(id: number, onlyActive: boolean, langID: number): Observable<DropdownItem[]> {
        this._spinnerService.show();
        return this._http.get<DropdownItem[]>(CONFIG.baseUrls.offlineDebates.getAllOfflineDebatesForDropdown + (id.toString() == null ? 0 : id.toString()) + "/" + onlyActive + "/" + langID.toString())
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getOfflineDebateById(id: number, langID: number): Observable<OfflineDebateDetail> {
        this._spinnerService.show();
        return this._http.get<OfflineDebateDetail>(CONFIG.baseUrls.offlineDebates.getOfflineDebateById + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getDebateBasicData(id: number, langID: number): Observable<DebateBasicData> {
        this._spinnerService.show();
        return this._http.get<DebateBasicData>(CONFIG.baseUrls.debates.getDebateById + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadOfflineDebateFile(debateFileId: number, langId: number): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.offlineDebates.downloadOfflineDebateFile, { ID: debateFileId, langID: langId }, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadOfflineDebateSessionFile(debateSessionFileId: number, langId: number): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.offlineDebates.downloadOfflineDebateSessionFile, { ID: debateSessionFileId, langID: langId }, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getOfflineDebateSessionDetail(id: number, langID: number): Observable<OfflineDebateSessionDetail> {
        this._spinnerService.show();
        return this._http.get<OfflineDebateSessionDetail>(CONFIG.baseUrls.offlineDebates.getOfflineDebateSessionDetail + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
}